:host {
    display: block;
}

.sort-filter-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;

    @include breakpointMin("lg") {
        gap: 13px;
    }

    &.hide-on-desktop {
      @media (min-width: 992px) {
        display: none;
      }
    }

    ::slotted([slot="label"]) {
        font-family: var(--primary-font);
        font-size: 16px;
        font-weight: var(--font-weight-bold);
        line-height: 22px;
        pointer-events: none;

        @include breakpointMin("lg") {
            font-size: 18px;
            font-weight: var(--font-weight-bold);
            line-height: 24px;
        }
    }
}
